import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { GroupAddSchema } from "@app/components/modals/GroupModal/groupAddSchema";
import { BlogpayLoginSchema } from "@app/components/modals/PlatformModal/blogpaySchema";
import {
  ModalProps,
  ModalContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
  Button,
  createModalComponent,
  DialogContent,
  useModal,
} from "@shortsworks/ui";
import {
  useGetApiKeyWithCustomerLogin,
  useUpdateApiKey,
} from "@shortsworks/user-api";
import { Suspense } from "react";
import { PlatformType } from "@app/types/platform";

interface BlogpayLoginContentProps {
  mallId: string;
}

const BlogpayLoginContent = (props: ModalProps<BlogpayLoginContentProps>) => {
  const { showModal } = useModal();
  const getApiKeyWithCustomerLogin = useGetApiKeyWithCustomerLogin();
  const updateApiKey = useUpdateApiKey();

  const blogpayLoginForm = useFormWithSchema({
    formSchemas: BlogpayLoginSchema,
    mode: "onChange",
  });

  const handleLoginBlogPay = async () => {
    const parsedForm = blogpayLoginForm.parseForm();
    if (!parsedForm.success) {
      return;
    }

    const { id, password } = parsedForm.data;

    const getApiKeyWithCustomerLoginResult =
      await getApiKeyWithCustomerLogin.mutateAsync({
        data: {
          id,
          password,
          platformType: PlatformType.BLOGPAY,
          mallId: props.mallId,
        },
      });

    if (getApiKeyWithCustomerLoginResult.error) {
      return showModal(CommonErrorModal, {
        title: "블로그페이 로그인에 실패했습니다.",
      });
    }

    const updateApiKeyResult = await updateApiKey.mutateAsync({
      data: {
        apiKey: getApiKeyWithCustomerLoginResult.data.token,
      },
    });

    if (updateApiKeyResult.data.success) {
      return showModal(CommonErrorModal, {
        title: "API 업데이트를 실패했습니다.",
      });
    }

    return props.close(true);
  };

  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>블로그페이 로그인</DialogTitle>
        <DialogDescription className="mt-2">
          블로그페이 아이디와 비밀번호는 블로그페이 API 키 재발급을 위해
          사용되며 저장되지 않습니다.
        </DialogDescription>
      </DialogHeader>
      <Suspense>
        <FormContainer
          className="mt-2"
          schemas={blogpayLoginForm.schemas}
          form={blogpayLoginForm.form}
        />
      </Suspense>
      <DialogFooter>
        <DialogClose asChild></DialogClose>
        <Button onClick={handleLoginBlogPay} className="p-0 w-[104px] h-[40px]">
          확인
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const BlogpayLoginModal = createModalComponent(BlogpayLoginContent);
